import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ChannelImages, ChannelService } from '../../services/channel.service';

/**
 * Stand-alone image viewer for one channel (T41049), opened in a new tab from the Step 2 list view.
 * Shows the channel's images one at a time; navigation only when there is more than one.
 */
@Component({
    selector: 'app-channel-image-viewer',
    templateUrl: './channel-image-viewer.component.html',
    styleUrls: ['./channel-image-viewer.component.scss']
})
export class ChannelImageViewerComponent implements OnInit, OnDestroy {
    public isLoading = true;
    public hasError = false;
    public channelName = '';
    public images: string[] = [];
    public currentIndex = 0;

    private subscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private channelService: ChannelService,
        private titleService: Title
    ) {}

    ngOnInit(): void {
        const channelId = this.route.snapshot.paramMap.get('channelId');
        this.subscription = this.channelService.getChannelImages(channelId).subscribe(
            (res: ChannelImages) => {
                this.channelName = res?.name || '';
                this.images = (res?.images || []).filter(Boolean);
                this.currentIndex = 0;
                if (this.channelName) this.titleService.setTitle(this.channelName);
                this.isLoading = false;
            },
            () => {
                this.hasError = true;
                this.isLoading = false;
            }
        );
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    get hasNavigation(): boolean {
        return this.images.length > 1;
    }

    get currentImage(): string {
        return this.images[this.currentIndex];
    }

    previous() {
        if (!this.hasNavigation) return;
        this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    }

    next() {
        if (!this.hasNavigation) return;
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }

    @HostListener('window:keydown', ['$event'])
    onKeydown(event: KeyboardEvent) {
        if (event.key === 'ArrowLeft') {
            this.previous();
        } else if (event.key === 'ArrowRight') {
            this.next();
        }
    }
}
